<div class="update-contact-dialog-content">
  <h4 class="modal-header">
    @if (!dialogData.edit) {
      <span>Add Contact</span
        >
        }@if (dialogData.edit) {
        <span>Edit Contact</span>
      }
      <span class="close-icon-dialog"
        ><mat-icon (click)="cancel()">close</mat-icon></span
        >
      </h4>
      @if (groupInfo$ | async; as groupInfo) {
      }
      <form [formGroup]="updateContactEmailInfoFormGroup" class="update-contact">
        <div class="form-wrapper">
          @if (dialogData.type === 'contact') {
            <div>
              Phone Number
              <div class="mat-row">
                <div class="mat-6 pad-r-2">
                  <mat-label>Type<span class="asterisk-mark">*</span></mat-label>
                  <mat-form-field floatLabel="never" class="full-width mat-custom-select">
                    <mat-select
                      placeholder="Select"
                      formControlName="phoneType"
                      [disabled]="dialogData.edit"
                      matNativeControl
                      (selectionChange)="onClientSelection($event)"
                      >
                      @for (type of types; track type) {
                        <mat-option [value]="type.value">
                          {{ type.name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <app-custom-mat-hint
                    [formGroup]="updateContactEmailInfoFormGroup"
                    controlName="phoneType"
                  ></app-custom-mat-hint>
                </div>
                <div class="mat-6">
                  <mat-label
                    >Phone Number<span class="asterisk-mark">*</span></mat-label
                    >
                    <mat-form-field floatLabel="never" class="full-width mat-custom-input">
                      <input
                        appPhoneNumberFormat
                        type="text"
                        matInput
                        placeholder="Enter Phone Number (555-555-5555)"
                        formControlName="phoneNumber"
                        />
                      </mat-form-field>
                      <app-custom-mat-hint
                        [formGroup]="updateContactEmailInfoFormGroup"
                        controlName="phoneNumber"
                      ></app-custom-mat-hint>
                    </div>
                  </div>
                </div>
              }
              @if (dialogData.type === 'email') {
                <div>
                  Email<span class="asterisk-mark">*</span>
                  <div class="mat-row">
                    <div class="mat-12">
                      <mat-form-field floatLabel="never" class="full-width mat-custom-input">
                        <input matInput placeholder="Enter Email" formControlName="email" />
                      </mat-form-field>
                      <app-custom-mat-hint
                        [formGroup]="updateContactEmailInfoFormGroup"
                        controlName="email"
                      ></app-custom-mat-hint>
                    </div>
                  </div>
                </div>
              }

              <div class="mat-row dialog-btn-row">
                <div class="mat-12" fxLayoutAlign="end end">
                  @if (dialogData.edit) {
                    <button
                      mat-button
                      class="primary-btn"
            [disabled]="
              !checkIfAnythingUpdated() || updateContactEmailInfoFormGroup.invalid || isSaving
            "
                      (click)="save()"
                      >
                      Save Changes
                    </button>
                  }
                  @if (!dialogData.edit) {
                    <button
                      mat-button
                      class="primary-btn"
            [disabled]="
              !checkIfAnythingUpdated() || updateContactEmailInfoFormGroup.invalid || isSaving
            "
                      (click)="save()"
                      >
                      Save Changes
                    </button>
                  }
                  <button mat-button class="secondary-btn" (click)="cancel()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>